import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=212ab1e9&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=212ab1e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ab1e9",
  null
  
)

export default component.exports